import React from "react";
var __jsx = React.createElement;
import { EditorBlock } from 'draft-js';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { BlockType } from '@uno/common-cms';
import { SelectedBlockWrapper } from 'components/common/RichTextEditor/CompositeDecorator/SelectedBlockWrapper';
import useGetBlockData from 'components/common/RichTextEditor/hooks/useGetBlockData';
import { Container, StyledTable, StyledTd } from './TableBlock.style';

var Wrapper = function Wrapper(_ref) {
  var isSelected = _ref.isSelected,
      children = _ref.children;
  return __jsx(SelectedBlockWrapper, {
    isSelected: isSelected
  }, children);
};
/**
 * Except for ordered & unordered lists, Draft does not natively support nesting a group of blocks
 * in a parent element as is needed for tables.
 * To handle tables, we store the table's size and styling specifications in the first table block
 * and render the entire table DOM structure when we render that first block, setting a data attribute
 * on each <td> element for its position in the table. Then as each subsequent block is rendered we use
 * createPortal from React-Dom to target the correct <td> element in the table to render that block into.
 */


var TableBlock = function TableBlock(props) {
  var _prevBlock$getKey, _tableData$tableShape;

  var block = props.block,
      _props$blockProps = props.blockProps,
      editor = _props$blockProps.editor,
      editorState = _props$blockProps.editorState;
  var contentState = editorState.getCurrentContent();

  var _useState = useState({
    tableKey: '',
    tablePosition: ''
  }),
      tableData = _useState[0],
      setTableData = _useState[1];

  var _useState2 = useState(false),
      isSelected = _useState2[0],
      setIsSelected = _useState2[1];

  var _useGetBlockData = useGetBlockData(editorState, block.getKey()),
      blockData = _useGetBlockData.blockData;

  useEffect(function () {
    setTableData(blockData);
    setIsSelected(block.getData().get('selected'));
  }, [block, blockData]);
  var prevBlock = contentState.getBlockBefore(block.getKey());

  var _useGetBlockData2 = useGetBlockData(editorState, (_prevBlock$getKey = prevBlock === null || prevBlock === void 0 ? void 0 : prevBlock.getKey()) !== null && _prevBlock$getKey !== void 0 ? _prevBlock$getKey : ''),
      prevBlockData = _useGetBlockData2.blockData; // if this is not the first table block, then the table's DOM structure has been rendered and we target the <td> element in the applicable position


  if (prevBlock !== undefined && prevBlock.getType() === BlockType.TABLE && prevBlockData.tableKey === tableData.tableKey) {
    var target = editor ? editor.editor.querySelector("[data-position='".concat(tableData.tablePosition, "']")) : null;

    if (target) {
      return /*#__PURE__*/createPortal(__jsx(EditorBlock, props), target);
    }

    return __jsx(React.Fragment, null);
  }

  return __jsx(Wrapper, {
    isSelected: isSelected
  }, __jsx(Container, null, __jsx(StyledTable, null, __jsx("tbody", null, (_tableData$tableShape = tableData.tableShape) === null || _tableData$tableShape === void 0 ? void 0 : _tableData$tableShape.map(function (row, rowIndex) {
    return __jsx("tr", {
      key: "".concat(tableData.tableKey, "-").concat(rowIndex)
    }, row.map(function (col, colIndex) {
      return __jsx(StyledTd, {
        key: "".concat(tableData.tableKey, "-").concat(rowIndex, "-").concat(colIndex),
        "data-position": "".concat(tableData.tableKey, "-").concat(rowIndex, "-").concat(colIndex)
      }, !!(rowIndex === 0 && colIndex === 0) && __jsx(EditorBlock, props));
    }));
  })))));
};

export default TableBlock;